import React, { useEffect, useState, useRef } from 'react';
import "./section1.css";
function Section1() {
  const [animate, setAnimate] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const galleryRef = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setAnimate(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0.1,
        rootMargin: '0px',
      }
    );

    if (galleryRef.current) {
      observer.observe(galleryRef.current);
    }

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <div className="container">
      <div className='sectionContainer1'>
        <div className="headerContainer">
          <div className="headerSection">
            <div className="header">
              <img src='/headerTop.png' alt="headerTop" className='headerTop' />
              <div className="headerText">
                <h5 className='stars'>★★★★★</h5>
                <h5 className="starText">95+ Business Transformations</h5>
              </div>
            </div>
            <div className="headerDesc">
              <h1 className="headerdescText">Elevate Your <span className='enhancedText'>Business</span> with <br /> Strategic <span className='enhancedText'>Operations</span> Solutions</h1>
            </div>
          </div>
          <div className="headerImg">
            <img src="/headerImg.png" alt="headerImg" className='headerImage' />
          </div>
        </div>
        <div className="container1Desc">
          <div className="description">
            <h4 className="descriptionText">Streamline your operations and unlock sustainable growth with our integrated backend solutions. We empower your business to scale efficiently through operational excellence.</h4>
          </div>
          <div className="containerButtons">
            <button className="getStarted">Explore Solutions</button>
            <button className="viewService">View Process</button>
          </div>
          <div className="headerImg">
            <div className="videoContainer">
              <video 
                ref={videoRef}
                src="/headerVideo.mp4" 
                muted 
                loop 
                className='headerVideo'
              />
              <div className="playButtonOverlay" onClick={togglePlay}>
                {!isPlaying && (
                  <div className="playButton">
                    <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="11" fill="rgba(255, 255, 255, 0.8)" stroke="#824deb" />
                      <path d="M9.5 7.5L16.5 12L9.5 16.5V7.5Z" fill="#824deb" />
                    </svg>
                  </div>
                )}
              </div>
              <div className="playButtonOverlay" onClick={togglePlay}>
                {!isPlaying && (
                  <div className="playButton">
                    <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="11" fill="rgba(255, 255, 255, 0.8)" stroke="#824deb" />
                      <path d="M9.5 7.5L16.5 12L9.5 16.5V7.5Z" fill="#824deb" />
                    </svg>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="sectionContainer2" id="about">
        <div className="containerLeft">
          <h1 className="journeyText">Our <span className='journeyEnhanced'>Excellence</span></h1>
          <p className="journeyDesc">
            We began as a dedicated team of operational specialists with a singular mission—to help businesses scale through structured backend excellence. Through years of refined execution, we've evolved into a comprehensive operational partner for forward-thinking companies, consistently delivering precision, reliability, and measurable results that drive sustainable growth.
          </p>
          <div className="journeyButtons">
            <button className="journeyStart">Schedule Consultation</button>
            <button className="journeyView">View Case Studies</button>
          </div>
          <div className="journeyBottomImg">
            <img src='/journeyImg.png' alt="Journey arrow" className='journeyImg' />
          </div>
        </div>
        <div className="containerRight">
          <div className="galleryWrapper" ref={galleryRef}>
            <div className="galleryLeft">
              <div className={`leftTop ${animate ? 'animate' : ''}`}>
                <img src="/journeyLeftTop.png" className='leftTopImg' alt="Office chairs"/>
              </div>
              <div className={`leftBottom ${animate ? 'animate': ''}`}>
                <img src="/journeyLeftBottom.png" className='leftBottomImg' alt="Workstation"/>
              </div>
            </div>
            <div className="galleryCenter">
              <div className={`centerLogo ${animate ? 'animate' : ''}`}>
                <img src="/journeyCenter.png" alt="Logo" className="purpleLogo" />
              </div>
            </div>
            <div className="galleryRight">
              <div className={`rightTop ${animate ? 'animate' : ''}`}>
                <img src="/journeyRightTop.png" alt="Working space" className="rightTopImg" />
              </div>
              <div className={`rightBottom ${animate ? 'animate' : ''}`}>
                <img src="/journeyRightBottom.png" alt="Clock and plant" className="rightBottomImg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Section1;